<template>
  <div class="branches_table grey loading_table">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-table
      default-sort="name"
      ref="table"
      pagination-simple
      per-page="15"
      :data="filteredUserCourses"
      paginated
      checkable
      :checked-rows.sync="rows.checked"
      detailed
      :show-detail-icon="false"
    >
      <template slot-scope="props">
        <b-table-column label="Название курса" :visible="true" field="name" :centered="false" sortable width="30%">
          <div @click="openInfo(props.row)">{{ props.row.name }}</div>
        </b-table-column>
        <b-table-column label="Категория" :visible="true" field="category.name" :centered="false" sortable width="20%">
          <div @click="openInfo(props.row)">{{ props.row.category.name }}</div>
        </b-table-column>
        <b-table-column label="Статус" :visible="true" field="status" :centered="false" sortable width="15%">
          <div @click="openInfo(props.row)">{{ setStatus(props.row.status) }}</div>
        </b-table-column>
        <b-table-column label="Начало" :visible="true" field="date_start" :centered="false" sortable width="15%">
          <div @click="openInfo(props.row)">{{ props.row.date_start | moment('DD.MM.YYYY') }}</div>
        </b-table-column>
        <b-table-column label="Окончание" :visible="true" field="date_end" :centered="false" sortable width="15%">
          <div @click="openInfo(props.row)">{{ props.row.date_end }}</div>
        </b-table-column>
      </template>
      <template slot="detail" slot-scope="props">
        <div class="table_actions">
          <button class="restore_course" @click="$emit('delete', props.row.id)">
            <i class="mdi mdi-file-document-box-remove-outline"></i> Убрать курс из списка
          </button>
          <button class="double_course" @click="openCoursePage(props.row)">
            <router-link :to="'/course-info/' + props.row.id">
              <i class="mdi mdi-file-eye-outline"></i> Страница курса
            </router-link>
          </button>
          <button class="edit_course" @click="openCourseEdit(props.row)">
            <router-link :to="'/all-courses/create/' + props.row.id">
              <i class="mdi mdi-square-edit-outline"></i> Редактировать курс
            </router-link>
          </button>
          <button class="add_course" @click="openCourseStatistic(props.row)">
            <router-link :to="'/all-courses/course-statistic/' + props.row.id">
              <i class="mdi mdi-chart-areaspline"></i> Статистика
            </router-link>
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    userCourses: {
      default: () => [],
      type: Array
    },
    rows: {
      default: () => {},
      type: Object
    },
    isLoading: {
      default: () => true,
      type: Boolean
    }
  },
  data() {
    return {
      openedRow: {}
    }
  },
  computed: {
    filteredUserCourses() {
      let data = this.userCourses
      data.forEach((el) => {
        el['date_end'] = this.$moment(el.date_start).add(el.days_limit, 'days').format('DD.MM.YYYY')
      })
      return data
    }
  },
  methods: {
    openInfo(row) {
      if (row != this.openedRow) {
        this.$refs.table.toggleDetails(this.openedRow)
        this.$refs.table.toggleDetails(row)
        this.openedRow = row
        return
      }
      this.$refs.table.toggleDetails(row)
      this.openedRow = {}
    },
    setStatus(status) {
      switch (status) {
        case 0:
          return 'Назначен'
        case 1:
          return 'В процессе'
        case 2:
          return 'Пройден'
        case 3:
          return 'Не пройден'
      }
    },
    openCourseEdit(val) {
      if (this.$browserDetect.isIE) {
        this.$router.push('/all-courses/create/' + val.id)
      }
    },
    openCoursePage(val) {
      if (this.$browserDetect.isIE) {
        this.$router.push('/course-info/' + val.id)
      }
    },
    openCourseStatistic(val) {
      if (this.$browserDetect.isIE) {
        this.$router.push('/all-courses/course-statistic/' + val.id)
      }
    }
  }
}
</script>
